import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-badge">
            <img src="/image/logotipo.png" alt="Eventoz Logo" className="hero-logo" />
            <span>🚀 Sistema de Gestão de Eventos</span>
          </div>
          <h1 className="hero-title">
            Gerencie seus eventos de forma
            <span className="gradient-text"> inteligente</span>
          </h1>
          <p className="hero-subtitle">
            Crie, divulgue e gerencie inscrições com facilidade. 
            Envie lembretes automáticos via WhatsApp e mantenha seus participantes sempre informados.
          </p>
          <div className="hero-buttons">
            <Link to="/register" className="btn btn-primary btn-large">
              Começar
            </Link>
            <Link to="/login" className="btn btn-success btn-large">
              Fazer Login
            </Link>
          </div>
          <div className="hero-stats">
            <div className="stat-item">
              <div className="stat-number">comece</div>
              <div className="stat-label">Grátis</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">∞</div>
              <div className="stat-label">Eventos</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">⚡</div>
              <div className="stat-label">Automático</div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Funcionalidades</span>
            <h2 className="section-title">Tudo que você precisa em um só lugar</h2>
            <p className="section-subtitle">
              Ferramentas completas para gerenciar eventos do início ao fim
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📅</div>
              <h3>Cadastro de Eventos</h3>
              <p>Crie eventos com imagens, descrição rica, data, local e limite de vagas.</p>
              <ul className="feature-list">
                <li>Upload de imagens</li>
                <li>Editor de texto avançado</li>
                <li>Controle de vagas</li>
              </ul>
            </div>

            <div className="feature-card featured">
              <div className="feature-badge">Destaque</div>
              <div className="feature-icon">📱</div>
              <h3>WhatsApp Automático</h3>
              <p>Envie lembretes automáticos via WhatsApp com integração Evolution API.</p>
              <ul className="feature-list">
                <li>Lembretes programados</li>
                <li>Envio em massa</li>
                <li>Mensagens personalizadas</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="feature-icon">🔗</div>
              <h3>Link Compartilhável</h3>
              <p>Gere links únicos para cada evento e compartilhe facilmente.</p>
              <ul className="feature-list">
                <li>QR Code automático</li>
                <li>Página de inscrição</li>
                <li>Validação de vagas</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="feature-icon">👥</div>
              <h3>Gestão de Inscritos</h3>
              <p>Visualize, gerencie e exporte a lista de participantes.</p>
              <ul className="feature-list">
                <li>Lista completa</li>
                <li>Exportação CSV</li>
                <li>Dados detalhados</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="feature-icon">🎲</div>
              <h3>Sistema de Sorteio</h3>
              <p>Sorteie vencedores entre os inscritos de forma justa e transparente.</p>
              <ul className="feature-list">
                <li>Sorteio aleatório</li>
                <li>Resultados instantâneos</li>
                <li>Histórico completo</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="feature-icon">⏰</div>
              <h3>Lembretes Inteligentes</h3>
              <p>Configure lembretes automáticos dias antes do evento.</p>
              <ul className="feature-list">
                <li>Programação flexível</li>
                <li>Com imagens</li>
                <li>Disparo automático</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Como Funciona</span>
            <h2 className="section-title">Simples e rápido</h2>
            <p className="section-subtitle">Em 4 passos você está pronto para gerenciar seus eventos</p>
          </div>

          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Cadastre-se</h3>
                <p>Crie sua conta gratuitamente em segundos</p>
              </div>
            </div>

            <div className="step-card">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Crie seu Evento</h3>
                <p>Adicione informações, imagem e configure as vagas</p>
              </div>
            </div>

            <div className="step-card">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Compartilhe</h3>
                <p>Envie o link do evento para seus participantes</p>
              </div>
            </div>

            <div className="step-card">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Gerencie</h3>
                <p>Acompanhe inscrições e envie lembretes automáticos</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="cta-content">
          <h2 className="cta-title">Pronto para começar?</h2>
          <p className="cta-subtitle">
            Crie sua conta gratuita e organize seus eventos de forma profissional
          </p>
          <div className="cta-buttons">
            <Link to="/register" className="btn btn-primary btn-large">
              Criar Conta Grátis
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <h3>📅 Eventoz</h3>
              <p>Sistema completo de gestão de eventos</p>
            </div>
            <div className="footer-links">
              <Link to="/login">Login</Link>
              <Link to="/register">Cadastro</Link>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 Eventoz. Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;